import ScenicAccordion from './scenic-accordion'

export default ScenicAccordion
